import { render, staticRenderFns } from "./editCollapse.vue?vue&type=template&id=bb908520&"
import script from "./editCollapse.vue?vue&type=script&lang=js&"
export * from "./editCollapse.vue?vue&type=script&lang=js&"
import style0 from "./editCollapse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports